import { useMemo } from 'react';
import { t } from 'i18next';

import { sortOptionsByValue } from '../helpers/sortOptions';

import { SuggestionItem } from '@innovationnorway/cl-react';

export type StatusFilterType = 'new' | 'recieved' | 'wip' | 'archived' | 'onhold' | 'opened';

const useStatusTags = () => {
  const statusOptions: SuggestionItem[] = useMemo(() => {
    return [
      {
        value: 'new',
        label: t('oneWayIn:status.New'),
      },
      {
        value: 'opened',
        label: t('oneWayIn:status.Opened'),
      },
      {
        value: 'wip',
        label: t('oneWayIn:status.wip'),
      },
      {
        value: 'archived',
        label: t('oneWayIn:status.Archived'),
      },
      {
        value: 'onhold',
        label: t('oneWayIn:status.FollowUpLater'),
      },
    ];
  }, []);

  return { statusOptions: sortOptionsByValue(statusOptions) };
};

export default useStatusTags;
